import { render } from "./ConfirmDefault.vue?vue&type=template&id=36bed1fc"
import script from "./ConfirmDefault.vue?vue&type=script&lang=js"
export * from "./ConfirmDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__